import React, { useEffect, useRef } from 'react';
import { CloseButton, BackwardButton } from '../Buttons/NavButtons';
import { KeyboardCodes } from '../Helpers';

const Header = ({ children, onCloseClick, onPreviousClick, title }) => {
    const prevRef = useRef(null);
    const closeRef = useRef(null);
    const titleRef = useRef(null);

    const internalKeyDown = e => {
        if ([KeyboardCodes.ENTER, KeyboardCodes.SPACE, KeyboardCodes.ESC].includes(e.keyCode)) {
            onCloseClick();
        }
    };

    const handleEscape = e => {
        e.keyCode === KeyboardCodes.ESC && onCloseClick();
    };

    useEffect(() => {
        title ? titleRef.current.focus() : closeRef.current.focus();

        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onPreviousClick, onCloseClick]);

    return (
        <header className="clx-step__header">
            {children}
            {onPreviousClick && <BackwardButton onClick={onPreviousClick} refObj={prevRef} />}
            {title && (
                <strong className="clx-step__header-title" tabIndex="0" ref={titleRef}>
                    {title}
                </strong>
            )}
            <CloseButton onClick={onCloseClick} onKeyDown={e => internalKeyDown} refObj={closeRef} />
        </header>
    );
};

export default Header;
